var RemoteWorkModule = /** @class */ (function () {
    function RemoteWorkModule(source, exportName) {
        this.source = source;
        this.exportName = exportName;
    }
    RemoteWorkModule.prototype.get = function () {
        var module = Function("\"use-strict\"; return " + this.source + ";").call(null);
        return module[this.exportName];
    };
    RemoteWorkModule.prototype.toString = function () {
        // needed to prevent issues when last char of source is ;
        var wrapped = "function(){\n      return " + this.source + "\n    }";
        return "" + wrapped;
    };
    return RemoteWorkModule;
}());
export default RemoteWorkModule;
